// @ts-nocheck
import { useCallback, useEffect, useState } from 'react';
import { ownerApi } from './ownerApi';
import PageHeader from './ui/PageHeader';
import Card from './ui/Card';
import Button from './ui/Button';
import Alert from './ui/Alert';

const RUNTIME_FIELDS = [
  ['customer_history_messages', 'Customer history messages'],
  ['customer_message_max_chars', 'Customer max characters'],
  ['product_search_cap', 'Product search cap'],
  ['catalog_evidence_cap', 'Catalog evidence cap'],
  ['max_retrieval_rounds', 'Max retrieval rounds'],
  ['max_agent_steps', 'Max agent steps'],
  ['max_tool_calls', 'Max tool calls'],
  ['owner_history_messages', 'Sol / owner history messages'],
  ['owner_message_max_chars', 'Sol / owner max characters'],
];

export default function OwnerRuntimeLimits() {
  const [tenantId, setTenantId] = useState('linas');
  const [runtime, setRuntime] = useState({});
  const [error, setError] = useState('');
  const [saved, setSaved] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const data = await ownerApi.platformCmSection(tenantId, 'runtime_limits');
      setRuntime(data.data.payload || {});
    } catch (err) {
      setError(err?.message || 'Could not load runtime limits.');
    } finally {
      setLoading(false);
    }
  }, [tenantId]);

  useEffect(() => {
    void load();
  }, [load]);

  async function save(event) {
    event.preventDefault();
    setSaving(true);
    setSaved('');
    setError('');
    try {
      const payload = Object.fromEntries(
        RUNTIME_FIELDS.map(([key]) => [key, Number(runtime[key] ?? 0)]),
      );
      const data = await ownerApi.savePlatformCmSection(tenantId, 'runtime_limits', payload);
      setRuntime(data.data.payload || payload);
      setSaved(`Saved and live for ${tenantId}.`);
    } catch (err) {
      setError(err?.message || 'Could not save runtime limits.');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <p className="p-6">Loading runtime limits…</p>;

  return (
    <div className="space-y-4">
      <PageHeader
        title="Runtime limits"
        subtitle="Customer Brain and Sol / Owner limits. Tenant AI Setup cannot edit these."
      />
      {error ? <Alert title={error} /> : null}
      {saved ? <p className="text-sm text-teal-800">{saved}</p> : null}
      <Card>
        <form onSubmit={save} className="grid max-w-xl gap-3">
          <label className="text-sm">
            Business (tenant id)
            <input
              aria-label="Business (tenant id)"
              className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3"
              value={tenantId}
              onChange={(event) => setTenantId(event.target.value)}
            />
          </label>
          {RUNTIME_FIELDS.map(([key, label]) => (
            <label key={key} className="text-sm">
              {label}
              <input
                aria-label={label}
                className="mt-1 h-9 w-full rounded-lg border border-[#7C8798] px-3"
                type="number"
                value={runtime[key] ?? ''}
                onChange={(event) => setRuntime((prev) => ({ ...prev, [key]: event.target.value }))}
              />
            </label>
          ))}
          <Button type="submit" loading={saving}>{saving ? 'Saving…' : 'Save runtime limits'}</Button>
        </form>
      </Card>
    </div>
  );
}
